// extracted by mini-css-extract-plugin
export default {"bar":"src-parts-operations-components-PartsOperationsList-components-BottomBar__bar--I3SVY"};